const ONBOARDING_VIDEO_EMBED_LINK = 'https://fast.wistia.net/embed/iframe/6d6rudlr5q?seo=false&videoFoam=true';
const ONBOARDING_VIDEO_URL = 'https://getsaral.wistia.com/medias/6d6rudlr5q?wvideo=6d6rudlr5q';
export { ONBOARDING_VIDEO_EMBED_LINK, ONBOARDING_VIDEO_URL };
